import React from "react";
import "./PremiumHistoryCard.css"; // optional styling

export default function PremiumHistoryCard({
  fullName,
  payment_mode,
  isPremiumStatus,
  date,
  time,
  imageUrl,
}) {
  // status badge colors
  const statusColors = {
    succeed: "#4CAF50", // green
    rejected: "#F44336", // red
    pending: "#FF9800", // orange
    interested:'blue'

  };

  return (
    <div className="history-card">
      {/* Left: icon + details */}
      <div className="history-left">
        <img src={imageUrl} alt={payment_mode} className="history-icon" />
        <div>
          <h4 className="history-label">{payment_mode}</h4>
          <p className="history-user">{fullName}</p>
          <span className="history-date">
            {date} | {time}
          </span>
        </div>
      </div>

      {/* Right: status */}
      <div className="history-right">
        <span
          className="history-status"
          style={{
            backgroundColor: statusColors[isPremiumStatus] || "#999",
          }}
        >
          {isPremiumStatus}
        </span>
      </div>
    </div>
  );
}
